import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import formatRupees from '../../utils/currency';
import { CopySVG } from '../icons';
import useCopyId from '../../helpers/copyId';

function PaymentInstalmentCard({
  instalmentNo, paymentDoneOn, dueDate, instalmentStatus, clearedAmount, instalmentId, dueFromDay,
}) {
  // console.log(instalmentNo, paymentDoneOn, instalmentStatus, clearedAmount, dueFromDay, 'instalmentCard');
  let DueDate = dueDate;
  const copyId = useCopyId();
  if (!dueDate) {
    DueDate = moment().add(dueFromDay, 'days').format('YYYY-MM-DD');
  }
  return (
    <div className="w-full mx-auto p-6 rounded-lg border border-[#B8E5FF] shadow-sm bg-white mb-4 ">
      <h2 className="text-base md:text-lg font-semibold text-gray-700 mb-2">
        Installment
        {instalmentNo}
      </h2>

      <div className="flex flex-col space-y-2">
        <div className="flex justify-between items-center">
          {paymentDoneOn ? (
            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Paid on:</span>
              <span className="text-sm md:text-base text-gray-800">{paymentDoneOn}</span>
            </div>
          ) : (
            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-sm md:text-base">Due on:</span>
              <span className="text-sm md:text-base text-gray-800">{DueDate}</span>
            </div>
          )}
          <div className={`flex gap-1 items-baseline ${
            // eslint-disable-next-line no-nested-ternary
            instalmentStatus === 'paid'
              ? 'text-green-600'
              : instalmentStatus === 'scheduled'
                ? 'text-[#9D6D06]'
                : 'text-[#FF675A]'
          }`}
          >
            <span className="font-semibold text-sm md:text-base">Status:</span>
            <span
              className="text-sm md:text-base font-medium"
            >
              {String(instalmentStatus).charAt(0).toUpperCase() + String(instalmentStatus).slice(1)}
            </span>
          </div>
        </div>

        <div className="flex justify-between items-center">

          <div className="flex gap-1 items-baseline">
            <span className="text-[#334155] font-semibold text-sm md:text-base">Amount:</span>
            <span className="text-sm md:text-base font-medium text-gray-800">
              {formatRupees(clearedAmount)}
            </span>
          </div>

          {/* <div className="flex gap-1 items-baseline">
            <span className="text-[#334155] font-semibold text-sm md:text-base">Paid via:</span>
            <span className=" text-sm md:text-base text-gray-800">Credit Card</span>
          </div> */}
        </div>

        <div className="flex justify-between items-center">
          <div className="flex gap-1 items-baseline">
            <span className="text-[#334155] font-semibold text-sm md:text-base">Instalment Ref ID:</span>
            <span className="text-sm md:text-base text-gray-800">
              {instalmentId.length > 10 ? `${instalmentId.slice(0, 10)}...` : instalmentId}
            </span>
          </div>
          <div>
            { /* TODO SHOW COPIED */}
            <button
              type="button"
              onClick={(e) => {
                copyId(e, { id: instalmentId, message: 'Transaction ID has been successfully copied' });
              }}
              className="text-white rounded-full h-7 w-7 flex items-center justify-center"
            >
              <CopySVG />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
PaymentInstalmentCard.propTypes = {
  instalmentNo: PropTypes.string.isRequired,
  paymentDoneOn: PropTypes.string.isRequired,
  instalmentStatus: PropTypes.string.isRequired,
  clearedAmount: PropTypes.string.isRequired,
  instalmentId: PropTypes.string.isRequired,
  dueDate: PropTypes.string,
  dueFromDay: PropTypes.number,
};
export default PaymentInstalmentCard;
